<div class="container-fluid block mt-5 mt-md-0">
    <div class="row box">
        <div class="col-12 col-md-3 offset-md-2">
            <a href="https://umarlestatuty.pl">
                <img
                        class="img-fluid"
                        src="/images/logo.svg"
                        alt="Stowarzyszenie Umarłych Statutów"
                />
            </a>
        </div>

        <div class="col-12 col-md-4 col-xxl-3 offset-md-1 my-5 my-md-0 description-container">
            <p class="description text-center text-md-left">
                Stowarzyszenie Umarłych Statutów to największa w Polsce organizacja
                zajmującą się obroną praw uczniów. W przypadku pytań związanych z
                publikacją lub naszą działalnością, zapraszamy do kontaktu:
                <span>kontakt</span><span>@</span><span>umarlestatuty</span><span>.</span><span>pl</span>.
            </p>
        </div>
    </div>
</div>

<style>
    .box {
        margin: 0 !important;
    }

    .block {
        display: flex;
        align-items: center;
        height: 50vh;
        padding: 0 !important;
        overflow-y: visible;
    }

    .description-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .description {
        font-family: "Work Sans";
        font-size: 14px;
        line-height: 16px;
        color: #425466;
        margin-bottom: 0;
    }

</style>
